import { render, staticRenderFns } from "./z-switch.vue?vue&type=template&id=8e6963cc&scoped=true&"
import script from "./z-switch.vue?vue&type=script&lang=js&"
export * from "./z-switch.vue?vue&type=script&lang=js&"
import style0 from "./z-switch.vue?vue&type=style&index=0&id=8e6963cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6963cc",
  null
  
)

export default component.exports